import React from 'react';

import { check } from '@/assets/icons';
import { classNames } from '@/helpers/classNames';
import { SvgIcon } from '@material-ui/core';

import styles from './SelectOptionsList.module.scss';

export type SelectOptionsListItem = {
	title: string;
	subtitle?: string;
	value: string | number | null;
};

type SelectOptionsListProps = {
	className?: string;
	items: SelectOptionsListItem[];
	value: string | number | null;
	onChange?: (value: string | number | null) => void;
};

export const SelectOptionsList: React.FC<SelectOptionsListProps> = ({
	className,
	items,
	value,
	onChange,
}) => {
	const classes = classNames([styles['root'], className]);

	return (
		<div className={classes}>
			{items.map((item, index) => (
				<SelectOptionsListItem
					key={item.value}
					position={getOrderPosition(items, index)}
					checked={item.value === value}
					onClick={() => onChange?.(item.value)}
					title={item.title}
					subtitle={item.subtitle}
					value={item.value}
				/>
			))}
		</div>
	);
};

type SelectOptionsListItemProps = {
	position: 'first' | 'middle' | 'last' | 'only';
	checked?: boolean;
	onClick: () => void;
} & SelectOptionsListItem;

const SelectOptionsListItem: React.FC<SelectOptionsListItemProps> = ({
	position,
	title,
	subtitle,
	checked,
	onClick,
	value,
}) => {
	return (
		<div
			className={classNames([styles['item'], styles[position]])}
			onClick={onClick}
		>
			<div className={styles['left']}>
				<div className={styles['title']}>{title}</div>
				{subtitle && (
					<div className={styles['subtitle']}>{subtitle}</div>
				)}
			</div>
			<div className={styles['right']}>
				{checked && (
					<div className={styles['icon']}>
						<SvgIcon component={check} />
					</div>
				)}
			</div>
		</div>
	);
};

const getOrderPosition = (items: SelectOptionsListItem[], index: number) => {
	if (!!items[index + 1] && !items[index - 1]) {
		return 'first' as const;
	}
	if (!!items[index + 1] && !!items[index - 1]) {
		return 'middle' as const;
	}
	if (!items[index + 1] && !!items[index - 1]) {
		return 'last' as const;
	}
	return 'only' as const;
};
